<template>
  <div class="container-fluid">
    <!-- <loader/> -->
    <!-- <pre>{{ sendReservation }}</pre>
    <pre>{{ sucursales }}</pre> -->
    <br><br>
    <!-- start reserve section-->
    <div class="" v-show="accion_reservar">
      <div>
        <b-alert v-model="welcome" fade>
          Bienvenido <b>&rArr;</b>
        </b-alert>
      </div>
      <b-row>
        <b-col md="8">
          <h3 class="heavy text-uppercase">{{$t('nueva_reserva.titulo_paso1')}}</h3>
        </b-col>
        <b-col md v-if="!auth">
          <a v-show="btn_modificar" href="" @click.prevent="modificar" class=" bold green float-right"><span>{{$t('reserve_step1and2.or')}}</span>{{$t('reserve_step1and2.modify')}}</a>
        </b-col>
        
        <b-col md v-else>
          <router-link :to="{name:'Panel'}" style="font-size:19px;" class="bold green float-right">RESERVAS ACTIVAS</router-link>
        </b-col>
      </b-row>
      <!--start select office -->
        <div class="">
          <p class="light text-uppercase"><b>{{ $t('reserve_step1and2.office_label') }}</b>  <span class="medium text-capitalize">({{ $t('reserve_step1and2.city_label') }})</span>*</p>
        </div>
    
      <div class="">
        <div class="">
          <!-- <input type="text" class="input-large" placeholder="pick-up location" autocomplete="off"> -->
          <div class="borderdiv">
              <select name="" id="" class="input-sucursal" v-model="sendReservation.sucursal_retiro">
                <option v-show="sucursal.enterprise == 1" :value="sucursal.id" :key="sucursal.id" @click="selecionSucursalSalida({id: sucursal.id, horario_semana: horario_sem})" v-for="sucursal in sucursales">{{sucursal.nombre_web}}</option>
              </select>
          </div>
        </div>
      </div>
      <!-- end select office -->

      <!-- start select return office -->
      <div class="">
        <div class="">
          <!-- <input type="checkbox" id="ck" class="input-check" @click="devolverOtraSucursal"> 
          <label for="ck" class="ml-2"> Devolver en otra oficina</label>
         -->
          <label class="customcheck mt-4">{{ $t('reserve_step1and2.return_label') }}
            <input type="checkbox" @click="devolverOtraSucursal">
            <span class="checkmark"></span>
          </label>
        </div>
      </div>

      <div class="" v-show="otraSucursal">
        <div class="" style="line-height: 1px;">
          <p class="light text-uppercase"><b>{{ $t('reserve_step1and2.office_dev') }}</b> <span class="medium text-capitalize">({{ $t('reserve_step1and2.city_label') }})</span>*</p>
        </div>
      </div>

      <div class="" v-show="otraSucursal">
        <div class="">
          <div class="borderdiv">
              <select name="" id="" class="input-sucursal" v-model="sendReservation.sucursal_devolucion">
                <option v-show="sucursal.enterprise == 1" :value="sucursal.id" :key="sucursal.id" @click="selecionSucursalEntrega(sucursal.id)" v-for="sucursal in sucursales">{{sucursal.nombre_web}}</option>
              </select>
          </div>
        </div>
      </div>
      <!-- end select return office -->

      <!-- select pick up time -->

      <b-row>
        <!-- pick uo column -->
        <b-col md="">
          <div class="mt-1">
            <p class="light text-uppercase"><b>{{ $t('reserve_step1and2.pick_date_label') }}*</b> </p>
          </div>
          <b-row class="m-1">
            <b-col class="no-padding" v-click-outside="closeCalendar1">
              <div class="borderdiv pt custom-select2" style="border-right:none"  @click="openCalendar1">
                <label class="green day pt">{{day(sendReservation.fecha_retiro)}}</label>
                <label class="medium mouth pt">{{month(sendReservation.fecha_retiro)}}<br>{{year(sendReservation.fecha_retiro)}}</label>
                <!-- <img src="/img/flecha.png" class="flecha" alt=""> -->
                <!-- <button class="btn btn-link btnSelect" @click="calendario_ent = !calendario_ent">
                  <i class="fa fa-chevron-down" aria-hidden="true"></i>
                  </button> -->
              </div>
              <div v-if="$i18n.locale === 'en'">
                <b-calendar locale="en-US" :min="minCalendar" :max="maxCalendar" today-variant="primary" v-show="calendario_sal" v-model="towDays" @context="contextDate"></b-calendar>
              </div>
              <div v-else>
                <b-calendar :min="minCalendar" :max="maxCalendar" locale="es-ES" today-variant="primary" v-show="calendario_sal" v-model="towDays" @context="contextDate"></b-calendar>
              </div>
              <!-- <b-calendar :min="minCalendar" today-variant="primary" v-show="calendario_sal" v-model="towDays" @context="contextDate"></b-calendar> -->
            </b-col>
            <b-col class="no-padding">
              <div class="borderdiv bckhour">
                <!-- <label class="green day">10:</label>
                <label class="medium mouth">00<br>00</label> -->
                <select class="custom-select selectHora" v-model="sendReservation.hora_retiro">
                  <option class="horas" :value="'00:00:00'">00:00</option>
                  <option class="horas" :value="'00:30:00'">00:30</option>
                  <option class="horas" :value="'01:00:00'">01:00</option>
                  <option class="horas" :value="'01:30:00'">01:30</option>
                  <option class="horas" :value="'02:00:00'">02:00</option>
                  <option class="horas" :value="'02:30:00'">02:30</option>
                  <option class="horas" :value="'03:00:00'">03:00</option>
                  <option class="horas" :value="'03:30:00'">03:30</option>
                  <option class="horas" :value="'04:00:00'">04:00</option>
                  <option class="horas" :value="'04:30:00'">04:30</option>
                  <option class="horas" :value="'05:00:00'">05:00</option>
                  <option class="horas" :value="'05:30:00'">05:30</option>
                  <option class="horas" :value="'06:00:00'">06:00</option>
                  <option class="horas" :value="'06:30:00'">06:30</option>
                  <option class="horas" :value="'07:00:00'">07:00</option>
                  <option class="horas" :value="'07:30:00'">07:30</option>
                  <option class="horas" :value="'08:00:00'">08:00</option>
                  <option class="horas" :value="'08:30:00'">08:30</option>
                  <option class="horas" :value="'09:00:00'">09:00</option>
                  <option class="horas" :value="'09:30:00'">09:30</option>
                  <option class="horas" :value="'10:00:00'">10:00</option>
                  <option class="horas" :value="'10:30:00'">10:30</option>
                  <option class="horas" :value="'11:00:00'">11:00</option>
                  <option class="horas" :value="'11:30:00'">11:30</option>
                  <option class="horas" :value="'12:00:00'">12:00</option>
                  <option class="horas" :value="'12:30:00'">12:30</option>
                  <option class="horas" :value="'13:00:00'">13:00</option>
                  <option class="horas" :value="'13:30:00'">13:30</option>
                  <option class="horas" :value="'14:00:00'">14:00</option>
                  <option class="horas" :value="'14:30:00'">14:30</option>
                  <option class="horas" :value="'15:00:00'">15:00</option>
                  <option class="horas" :value="'15:30:00'">15:30</option>
                  <option class="horas" :value="'16:00:00'">16:00</option>
                  <option class="horas" :value="'16:30:00'">16:30</option>
                  <option class="horas" :value="'17:00:00'">17:00</option>
                  <option class="horas" :value="'17:30:00'">17:30</option>
                  <option class="horas" :value="'18:00:00'">18:00</option>
                  <option class="horas" :value="'18:30:00'">18:30</option>
                  <option class="horas" :value="'19:00:00'">19:00</option>
                  <option class="horas" :value="'19:30:00'">19:30</option>
                  <option class="horas" :value="'20:00:00'">20:00</option>
                  <option class="horas" :value="'20:30:00'">20:30</option>
                  <option class="horas" :value="'21:00:00'">21:00</option>
                  <option class="horas" :value="'21:30:00'">21:30</option>
                  <option class="horas" :value="'22:00:00'">22:00</option>
                  <option class="horas" :value="'22:30:00'">22:30</option>
                  <option class="horas" :value="'23:00:00'">23:00</option>
                  <option class="horas" :value="'23:40:00'">23:30</option>

                </select>
                
              </div>
            </b-col>
            
          </b-row>
        </b-col>
        <!-- return column -->
        <b-col md="">
          <div class="mt-1">
            <p class="light text-uppercase"><b>{{$t('reserve_step1and2.return_date_label')}}*</b> </p>
          </div>
          <b-row class="m-1">
            <b-col class="no-padding" v-click-outside="closeCalendar2">
               <div class="borderdiv pt custom-select2" style="border-right:none"  @click="openCalendar2">
                <label class="green day pt">{{day(sendReservation.fecha_devolucion)}}</label>
                <label class="medium mouth pt">{{month(sendReservation.fecha_devolucion)}}<br>{{year(sendReservation.fecha_devolucion)}}</label>
                <!-- <img src="/img/flecha.png" class="flecha" alt=""> -->
              </div>

              <div v-if="$i18n.locale === 'en'">
                <b-calendar locale="en-US" :min="minCalendar" :max="maxCalendar" today-variant="primary" v-show="calendario_ent" v-model="fourDays" @context="contextDate2"></b-calendar>
              </div>
              <div v-else>
                <b-calendar :min="minCalendar" :max="maxCalendar" locale="es-ES" today-variant="primary" v-show="calendario_ent" v-model="fourDays" @context="contextDate2"></b-calendar>
              </div>
              <!-- <b-calendar :min="minCalendar" today-variant="primary" v-show="calendario_ent" v-model="fourDays" @context="contextDate2"></b-calendar> -->
        
            </b-col>
            <b-col class="no-padding">
               <div class="borderdiv bckhour">
                <select class="custom-select selectHora" v-model="sendReservation.hora_devolucion">
                  <option class="horas" :value="'00:00:00'">00:00</option>
                  <option class="horas" :value="'00:30:00'">00:30</option>
                  <option class="horas" :value="'01:00:00'">01:00</option>
                  <option class="horas" :value="'01:30:00'">01:30</option>
                  <option class="horas" :value="'02:00:00'">02:00</option>
                  <option class="horas" :value="'02:30:00'">02:30</option>
                  <option class="horas" :value="'03:00:00'">03:00</option>
                  <option class="horas" :value="'03:30:00'">03:30</option>
                  <option class="horas" :value="'04:00:00'">04:00</option>
                  <option class="horas" :value="'04:30:00'">04:30</option>
                  <option class="horas" :value="'05:00:00'">05:00</option>
                  <option class="horas" :value="'05:30:00'">05:30</option>
                  <option class="horas" :value="'06:00:00'">06:00</option>
                  <option class="horas" :value="'06:30:00'">06:30</option>
                  <option class="horas" :value="'07:00:00'">07:00</option>
                  <option class="horas" :value="'07:30:00'">07:30</option>
                  <option class="horas" :value="'08:00:00'">08:00</option>
                  <option class="horas" :value="'08:30:00'">08:30</option>
                  <option class="horas" :value="'09:00:00'">09:00</option>
                  <option class="horas" :value="'09:30:00'">09:30</option>
                  <option class="horas" :value="'10:00:00'">10:00</option>
                  <option class="horas" :value="'10:30:00'">10:30</option>
                  <option class="horas" :value="'11:00:00'">11:00</option>
                  <option class="horas" :value="'11:30:00'">11:30</option>
                  <option class="horas" :value="'12:00:00'">12:00</option>
                  <option class="horas" :value="'12:30:00'">12:30</option>
                  <option class="horas" :value="'13:00:00'">13:00</option>
                  <option class="horas" :value="'13:30:00'">13:30</option>
                  <option class="horas" :value="'14:00:00'">14:00</option>
                  <option class="horas" :value="'14:30:00'">14:30</option>
                  <option class="horas" :value="'15:00:00'">15:00</option>
                  <option class="horas" :value="'15:30:00'">15:30</option>
                  <option class="horas" :value="'16:00:00'">16:00</option>
                  <option class="horas" :value="'16:30:00'">16:30</option>
                  <option class="horas" :value="'17:00:00'">17:00</option>
                  <option class="horas" :value="'17:30:00'">17:30</option>
                  <option class="horas" :value="'18:00:00'">18:00</option>
                  <option class="horas" :value="'18:30:00'">18:30</option>
                  <option class="horas" :value="'19:00:00'">19:00</option>
                  <option class="horas" :value="'19:30:00'">19:30</option>
                  <option class="horas" :value="'20:00:00'">20:00</option>
                  <option class="horas" :value="'20:30:00'">20:30</option>
                  <option class="horas" :value="'21:00:00'">21:00</option>
                  <option class="horas" :value="'21:30:00'">21:30</option>
                  <option class="horas" :value="'22:00:00'">22:00</option>
                  <option class="horas" :value="'22:30:00'">22:30</option>
                  <option class="horas" :value="'23:00:00'">23:00</option>
                  <option class="horas" :value="'23:30:00'">23:30</option>

                </select>
              </div>
            </b-col>
          </b-row>
        </b-col>
        
        <b-col md="4">
          <div class="mt-1">
            <p class="light text-uppercase"><b>{{$t('reserve_step1and2.age_label')}}*</b> </p>
          </div>
          <div class="borderdiv " style="height:76px;">
            <select class=" selectEdad flecha " style="height:72px;" v-model="sendReservation.edad">
                  <option class="edad" :value="'23'">23</option>
                  <option class="edad" :value="'24'">24</option>
                  <option class="edad" :value="'25'">25+</option>
            </select>
          </div>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col md="8" class="mt-2 ">
          <!-- <input type="text" class="input-large borderdiv" placeholder="código promocional o número de cuenta (opcional)" autocomplete="off">
          <br> -->
        </b-col>
        <b-col md="4" class="mt-2">
          <!-- <button class="btnr" @click="preCalculo">Continue</button> -->
          <b-button v-if="$route.name === 'Fleet'" block squared @click="seleccionVehiculoFleet" class="button">{{$t('buttons_label.continue')}}</b-button>
          <b-button v-else block squared @click="preCalculo" class="button">{{$t('buttons_label.continue')}}</b-button>
          <br>
        </b-col>
      </b-row>
    </div>
    <!-- end reserve section-->

    <!-- start modify section-->
    <div class="" v-show="modificar_reserva">
      <form @submit.prevent="buscarReservaModificar({num_reserva,apellido_paterno, brand:3})">
        <b-row>
          <b-col md="8">
            <h3 class="heavy2 text-uppercase">{{$t('reserve_step1and2.modify')}}</h3>
          </b-col>
          <b-col md>
            <a href="" @click.prevent="reservar" class="float-right bold green text-uppercase"><span>O</span>{{$t('nueva_reserva.titulo_paso1')}}</a>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
              <div v-show="errors.error" class="box-error">
                  <strong>ERROR:</strong>
                  <span v-if="$i18n.locale==='es'" class="msg-error">
                    {{ errors.es }}
                  </span>
                  <span v-else class="msg-error">
                    {{ errors.en }}
                  </span>
              </div>
              <p class="light">{{$t('Modify_view_table.numero_label')}}<span class="medium"></span></p>
              <input type="text" class="input-large" placeholder="" autocomplete="off" v-model="num_reserva">
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <p class="light">{{$t('Modify_view_table.lastname_label')}}<span class="medium"></span></p>
            <input type="text" class="input-large" placeholder="" autocomplete="off" v-model="apellido_paterno">
          </b-col>
        </b-row>
        <br>
        <!--mobile-->
        <b-row>
          <b-col class="d-lg-none">
              <button class="btn btn-success btnr float-right">{{$t('Modify_view_table.btn_label')}}</button>
          </b-col>
        </b-row>
        <!--mobile-->
        <b-row>
          <b-col class="d-none d-lg-block">

          </b-col>
          <b-col class="d-none d-lg-block">
            
          </b-col>
          <b-col class="d-none d-lg-block">
            <button class="btn btn-success btnr float-right rounded-0">{{$t('Modify_view_table.btn_label')}}</button>
          </b-col>
        </b-row>

      </form>
      <!-- <form @submit.prevent="buscarReservaModificar({num_reserva,apellido_paterno, tipo_cliente})">
      <div class="row container-fluid">
        <div class="col-8">
          <h3 class="heavy text-uppercase">{{$t('reserve_step1and2.modify')}}</h3>
        </div>
        <div class="col-4">
          <a href="" @click.prevent="reservar" class="float-right bold green"><span>O</span>REALIZAR UNA RESERVA</a>
        </div>
      </div>

      
      <div class="row container-fluid">
        <div class="col-12">
          <div v-show="errors.error" class="box-error">
            <strong>ERROR:</strong>
            <span class="msg-error">
               {{ errors.es }}
          </span>
          </div>
          <p class="light">Número de Reserva<span class="medium"></span></p>
          <input type="text" class="input-large" placeholder="" autocomplete="off" v-model="num_reserva">

          <p class="light">Apellido Paterno<span class="medium"></span></p>
          <input type="text" class="input-large" placeholder="" autocomplete="off" v-model="apellido_paterno">
        </div>
      </div>

      
            
        <br>
      <div class="row container-fluid">
        <div class="col-md-12 d-lg-none">
            <button class="btn btn-success btnr">Encontrar Reservación</button>
        </div>
        <div class="col-4 d-none d-lg-block">
            
        </div>
        <div class="col-4 d-none d-lg-block">
            
        </div>
        <div class="col-4 d-none d-lg-block">
            <button class="btn btn-success btnr float-right">Encontrar Reservación</button>
        </div>
      </div>
      </form> -->
    </div>
    <!-- end modify section-->


    <!--resultado de la busqueda-->
      <div class="" v-if="accionBuscar">
        <!--primer row-->
        <b-row>
          <b-col>
                <h3 class="heavy2 text-uppercase">{{$t('reserve_step1and2.modify')}}</h3>
          </b-col>
          <b-col>
                <a href="" @click.prevent="reservar" class="float-right bold green"><span>{{$t('reserve_step1and2.or')}}</span>{{$t('reserve_step1and2.title')}}</a>
          </b-col>
        </b-row>
        <!--fin primer row-->

        <!--segundo row-->
        <b-row>
          <b-col>
              <div class="card">
                <div class="card-header">
                  <h5>{{fecha_retiro_corta}} - {{ fecha_entrada_corta }}</h5>
                  <span>{{$t('modify.mod2')}} {{ getReserve.id }}</span> |
                  <b-button @click="detallesReserva({num_reserva:getReserve.id, brand:3})" variant="link" class="btnlinks text-uppercase">{{$t('modify.mod10')}}</b-button> |
                  <b-button @click="modificarReserva({num_reserva:getReserve.id, brand:3})" variant="link" class="btnlinks text-uppercase">{{$t('step5.st8')}}</b-button> |
                  <b-button 
                      class="btnlinks text-uppercase"
                      variant="link"
                      data-toggle="modal" 
                      data-target="#cancelModal"
                      >{{$t('modify.mod11')}}
                  </b-button>
                  <modalcancel :id="num_reserva"></modalcancel> 
                  <img :src="getReserve.auto.image.url_imagen" alt="" class="car">
                </div>
          <div class="card-body">
            <b-row>
              <b-col>
                  <p class="titleDetails">PICK-UP</p>
                  <span>{{ getReserve.retiro.nombre_web }}</span><br>
                  <span>{{fecha_retiro}}</span>
              </b-col>

              <b-col>
                  <p class="titleDetails">RETURN</p>
                  <span>{{ getReserve.devolucion.nombre_web }}</span><br>
                  <span>{{fecha_entrada}}</span>
              </b-col>

              <b-col>
                  <p class="titleDetails">VEHICLE</p>
                  <span>{{ getReserve.auto.marca  }} {{ getReserve.auto.modelo  }} or similar</span>
                  <br>
                  <span><i class="icon-transmission ic"></i> {{ getReserve.auto.transmision }}</span>
                  
              </b-col>
            </b-row>
            <!-- <div class="row">
              <div class="col-sm-4 bordes-detalles-auto">
                <p class="titleDetails">PICK-UP</p>
                <span>{{ getReserve.retiro.nombre_web }}</span><br>
                <span>{{fecha_retiro}}</span>
              </div>
              <div class="col-sm-4 bordes-detalles-auto">
                <p class="titleDetails">RETURN</p>
                <span>{{ getReserve.devolucion.nombre_web }}</span><br>
                <span>{{fecha_entrada}}</span>
              </div>
              <div class="col-sm-4">
                <p class="titleDetails">VEHICLE</p>
                <span>{{ getReserve.auto.marca  }} {{ getReserve.auto.modelo  }} or similar</span>
                <img :src="getReserve.auto.image.url_imagen" alt="" class="car"><br>
                <span><i class="icon-transmission ic"></i> {{ getReserve.auto.transmision }}</span>
              </div>
            </div> -->
          </div>
        </div>
          </b-col>
        </b-row>
        <!--fin segundo row-->

        <div class="row">
        <div class="col-6">
          <!-- <h3 class="heavy text-uppercase">{{$t('reserve_step1and2.modify')}}</h3> -->
        </div>
        <div class="col-6">
          <!-- <a href="" @click.prevent="reservar" class="float-right bold green"><span>O</span>REALIZAR UNA RESERVA</a> -->
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <!-- <div class="card">
          <div class="card-header">
            <h5>{{fecha_retiro_corta}} - {{ fecha_entrada_corta }}</h5>
            <span>Confirmation Number: {{ getReserve.id }}</span> |
            <b-button @click="detallesReserva({num_reserva:getReserve.id, brand:3})" variant="link" class="btnlinks">Ver Detalles</b-button> |
            <b-button @click="modificarReserva({num_reserva:getReserve.id, brand:3})" variant="link" class="btnlinks">Modificar</b-button> |
            <b-button 
                class="btnlinks"
                variant="link"
                data-toggle="modal" 
                data-target="#cancelModal"
                >Cancelar
            </b-button>
            <modalcancel :id="num_reserva"></modalcancel> 
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-sm-4 bordes-detalles-auto">
                <p class="titleDetails">PICK-UP</p>
                <span>{{ getReserve.retiro.nombre_web }}</span><br>
                <span>{{fecha_retiro}}</span>
              </div>
              <div class="col-sm-4 bordes-detalles-auto">
                <p class="titleDetails">RETURN</p>
                <span>{{ getReserve.devolucion.nombre_web }}</span><br>
                <span>{{fecha_entrada}}</span>
              </div>
              <div class="col-sm-4">
                <p class="titleDetails">VEHICLE</p>
                <span>{{ getReserve.auto.marca  }} {{ getReserve.auto.modelo  }} or similar</span>
                <img :src="getReserve.auto.image.url_imagen" alt="" class="car"><br>
                <span><i class="icon-transmission ic"></i> {{ getReserve.auto.transmision }}</span>
              </div>
            </div>
          </div>
        </div> -->
        <br>
        <button class="btn btn-outline-success float-right rounded-0">{{$t('modify.mod12')}}</button>
        </div>
      </div>

    </div>
    <!--resultado de la busqueda-->
    <br><br>
      
      
    
  </div>
</template>

<script>
import loader                     from '@/components/loader.vue'
import moment                     from 'moment'
import modalcancel                from '@/components/ModalCancelReserve'
import ClickOutside               from 'vue-click-outside'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

  export default {
    
    name: 'reservestep1and2',
    components:{
      loader, 
      modalcancel,
    },
    /* metaInfo:{
      title: "Reservar con enterprise Panamá",
      meta: [{
        vmid: 'Enterprise Panamá',
        name: 'description',
        content: 'Arriendo de vehiculos en Panamá. Empresa dedicada al arriendo de vehículos en Panamá, entre otros: automoviles, camionetas, van.',
      }]
    }, */
    mounted () {
      
      if(this.$route.name === 'Home'){
        this.resetValues()
        //console.clear()
      }

      if(
          this.$route.name === 'Fleet'      || 
          this.$route.name === 'Weekend'    || 
          this.$route.name === 'Greenweek'  || 
          this.$route.name === 'Twoonefree' ||
          this.$route.name === 'Pack3d'     ||
          this.$route.name === 'Pack4d'     ||
          this.$route.name === 'Bymonth')
          {
        this.btn_modificar = !this.btn_modificar
        this.resetValues()
      }

      //carga las sucursales
      this.primerPaso()

     
    },
    data() {
      return {
        showAlert: Boolean,
        num_reserva: '',
        apellido_paterno: '',
        tipo_cliente: 3,
        btn_modificar:true,
        inClic: false
      }
    },
    directives: {
    ClickOutside
  },
  watch: {
    welcome(newValue, oldValue) {
      if(newValue){
        this.showWelcome()
      }
    }
  },
    computed: {
      ...mapState('reserva', [  
                                'errors',
                                'sucursales', 
                                'otraSucursal', 
                                'sendReservation', 
                                'calendario_sal', 
                                'calendario_ent', 
                                'loader', 
                                'buscarReserva', 
                                'getReserve', 
                                'accionBuscar',
                                'accion_reservar',
                                'modificar_reserva'
                              ]),
      ...mapState('autenticacion', ['auth', 'welcome']),
      minCalendar(){
        return new Date().toISOString().split("T")[0]
      },
      maxCalendar()
      {
        return moment().add(1, 'years').format('YYYY-MM-DD')
      },
      fecha_retiro(){
        return moment(this.getReserve.fecha_retiro).format('LLL')
      },
      fecha_entrada(){
        return moment(this.getReserve.fecha_entrada).format('LLL')
      },
      fecha_retiro_corta(){
        return moment(this.getReserve.fecha_retiro).format('ll')
      },
      fecha_entrada_corta(){
        return moment(this.getReserve.fecha_entrada).format('ll')
      },
      towDays:
      {
        get()
        {
          
          if(this.$route.name === 'Weekend')
          {
            
            let day1 = moment().day(5).format('YYYY-MM-DD')
            return this.sendReservation.fecha_retiro = day1
            
          }else if(this.$route.name === 'Greenweek'){

            let day1 = moment().format('YYYY-MM-DD')
    
            return this.sendReservation.fecha_retiro = day1

          }else if(this.$route.name === 'Twoonefree'){

            let day1 = moment().format('YYYY-MM-DD')
    
            return this.sendReservation.fecha_retiro = day1

          }else if(this.$route.name === 'Pack3d'){

            let day1 = moment().format('YYYY-MM-DD')
    
            return this.sendReservation.fecha_retiro = day1

          }else if(this.$route.name === 'Pack4d'){

            let day1 = moment().format('YYYY-MM-DD')
    
            return this.sendReservation.fecha_retiro = day1

          }else if(this.$route.name === 'Bymonth'){

            let day1 = moment().format('YYYY-MM-DD')
    
            return this.sendReservation.fecha_retiro = day1

          }
          
          else{
            let day1 = moment().add(2, 'days').format('YYYY-MM-DD')
            return this.sendReservation.fecha_retiro = day1
          }
          
        },

        set(date)
        {
          this.updateFirstCalendar(date)
        }
      },

      fourDays:
      {
        get()
        {
          if(this.$route.name === 'Weekend')
          {
            
            let day = moment().day(5).format('YYYY-MM-DD')
            let day1 = moment(day).add(3, 'days').format('YYYY-MM-DD')
            
            return this.sendReservation.fecha_devolucion = day1
            
          }else if(this.$route.name === 'Greenweek'){

            let day = moment().format('YYYY-MM-DD')
            let day1 = moment(day).add(7, 'days').format('YYYY-MM-DD')
            return this.sendReservation.fecha_retiro = day1

          }else if(this.$route.name === 'Twoonefree'){

            let day = moment().format('YYYY-MM-DD')
            let day1 = moment(day).add(2, 'days').format('YYYY-MM-DD')
            return this.sendReservation.fecha_retiro = day1

          }else if(this.$route.name === 'Pack3d'){

            let day = moment().format('YYYY-MM-DD')
            let day1 = moment(day).add(3, 'days').format('YYYY-MM-DD')
            return this.sendReservation.fecha_retiro = day1

          }else if(this.$route.name === 'Pack4d'){

            let day = moment().format('YYYY-MM-DD')
            let day1 = moment(day).add(4, 'days').format('YYYY-MM-DD')
            return this.sendReservation.fecha_retiro = day1

          }else if(this.$route.name === 'Bymonth'){

            let day = moment().format('YYYY-MM-DD')
            let day1 = moment(day).add(30, 'days').format('YYYY-MM-DD')
            return this.sendReservation.fecha_retiro = day1

          }
          else{
            let day = moment().add(4, 'days').format('YYYY-MM-DD')
            return this.sendReservation.fecha_devolucion = day
          }
          
        },

        set(date)
        {
          this.updateSecondCalendar(date)
        }
        
      }
       
    },
    methods: {
      ...mapActions('reserva', ['primerPaso', 'preCalculo', 'buscarReservaModificar', 'detallesReserva', 'modificarReserva', 'seleccionVehiculoFleet']),
      ...mapMutations('reserva', [
                                  'selecionSucursalSalida',
                                  'selecionSucursalEntrega',
                                  'devolverOtraSucursal',
                                  'contextDate', 
                                  'contextDate2', 
                                  'updateFirstCalendar', 
                                  'updateSecondCalendar', 
                                  'openCalendar1', 
                                  'closeCalendar1',
                                  'openCalendar2',
                                  'closeCalendar2',
                                  'resetValues',
                                  'modificar',
                                  'reservar'
                                  ]),
      ...mapMutations('autenticacion', ['WELCOME']),
      // metodo para mostrar el día
      day(d){
        return moment(d).format('D')
      },

      // metodo para mostrar el mes 
      month(m){
        return moment(m).format('MMM')
      },

      // metodo para mostrar el año 
      year(y){
        return moment(y).format('YYYY')
      },

      botonReserva(){
        this.modificar_reserva = !this.modificar_reserva
        this.accionBuscar = !this.accionBuscar
        this.getReserve = {}
      },
      showWelcome() {
        setTimeout(() => {
          this.WELCOME()
        }, 4000);
      }
    },
  }
</script>

<style lang="scss" scoped>
@font-face {
    font-family: 'DIN 2014-ExraBold';
    src: url('../assets/fonts/DIN2014-ExtraBold.ttf');

}
@font-face {
    font-family: 'DIN 2014-Regular';
    src: url('../assets/fonts/DIN2014-Regular.ttf');
}
select {
    -webkit-appearance: none;
    -moz-appearance: none;
    text-indent: 1px;
    text-overflow: '';
}

.heavy{
  font-family: 'DIN 2014-ExraBold', 'Arial Black', Arial, Helvetica, sans-serif;
  font-size: 32px;
  line-height: 36px;
}
.heavy2{
  font-family: 'DIN 2014-ExraBold', 'Arial Black', Arial, Helvetica, sans-serif;
  font-size: 30px;
  line-height: 36px;
}
a{
  line-height: 36px;
  span{
    color: #c3c3c3; 
    margin-top: 2px; 
    margin-right: 7px;
  }
}

.green, .green:hover {
    color: #169A5A;
}
.bold {
    font-family: 'DIN 2014-ExraBold', 'Arial Black', Arial, sans-serif;
    font-size: 15px;
}
.light {
    font-family: 'DIN 2014-Regular', Helvetica, Arial, sans-serif;
    font-size: 15px;
    padding-top: 33px;
    color: #181918;
}
.medium {
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    font-size: 15px;
}
.no-padding {
  padding-left: 0;
  padding-right: 0;
}
.input-large{
  border: 1px solid #c2c2c2; 
  height: 60px; 
  padding-left: 15px; 
  font-size: 20px; 
  width: 100%;
}
.input-sucursal{
  border: none; 
  height: 60px; 
  padding-left: 15px; 
  padding-right: 15px; 
  font-size: 20px; 
  width: 99.9%;
  background: url("/img/flecha.png") no-repeat right/15px;
    background-position: 98% 24px;
    background-color: rgb(255, 255, 255);
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
.input-sucursal:focus {
  outline: 2px solid #a4ceff !important;
}
.input-check{ 
  margin-top: 1.5%;
}
.btnr{
  background-color: #169A5A;
  color: white;
  border-radius: 0%;
  width: 100%;
  height: 100%;
}
.button{
  font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
  color: #FFFFFF;
  size: 14px;
  letter-spacing: 0.9px;
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
  background: #169A5A;
  height: 100%;
  border: none;
}
.button:hover{
  background:#006639;
}
.date{
  margin-left: 0%;
}
.day{
  padding-top: 10px; 
  padding-left: 15px; 
  font-size: 43px; 
  line-height: 53px;
}
.mouth{
  padding-top: 8px; 
  font-size: 13px; 
  height: 19px; 
  padding-bottom: 5px;
}
.fa-arrow-right{
  padding: 25px 27px;
}
.col-sm-1 {
    max-width: 7%;
}
.edad{
  margin-left: 3%;
  max-width: 22%;
}

.selectHora{
  width: 100%;
  font-size: 38px; 
  border: none;
  color:#169A5A;
  padding: 0px;



  .horas{
    color: rgb(27, 27, 27);
    font-size: 16px;
  } 
}
.bckhour{
  background-color: #f3f3f3;
}
.custom-select {
    background: url("/img/flecha.png") no-repeat right/15px ;
    background-position: 95% 30px;
    //background-color: #f3f3f3;
    border: 0px  #ffffff;
    border-radius: 0rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    
}
.custom-select2 {
    background: url("/img/flecha.png") no-repeat right/15px;
    background-position: 95% 30px;
    background-color: rgb(255, 255, 255);
    border: 0px  #ffffff;
    border-radius: 0rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
.pt{
   cursor: pointer;
}
.flecha{
  background: url("/img/flecha.png") no-repeat right/15px ;
  background-position: 95% 30px;
   /*  position: float;
    margin-top: 21%;
    margin-left: 12%;
    right: 0%;
    width: 10%; */
}

.selectEdad{
  padding-left: 5%;
  width: 100%;
  height: 83%;
  background-color: #ffffff;
  font-size: 20px; 
  border: none;
  color:#181918;
  
  /* padding: 7px; */

  .edad{
    color: rgb(15, 15, 15);
    font-size: 16px;
  } 
}
.selectEdad:focus {
  outline: 2px solid #a4ceff !important;
}
.card{
  border-radius: 0px;
}
.btnlinks{
  font-family: 'DIN 2014-ExraBold', 'Arial Black', Arial, sans-serif;
  color: #169A5A;
  font-weight: 900;
  font-size: 15px;
}

.icon-transmission{
    background-image: url('/img/transmission_type.svg');
    background-size: 100%;
    background-repeat: no-repeat;
}
.ic{
    display: inline-block;
    width: 17px;
    height: 16px;
}
.titleDetails{
  font-weight: bold;
}
.car{
  float: right;
  // margin-right: -10%;
  margin-top: -7%;
}

.titles2{
  color: #181918; 
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
  font-size: 15px;
  font-weight: 600;
  height: 20px;
}
.borderdiv{
  border-radius: 0px;
  border: solid 2px #b8b8b8;
}
.borderdiv:focus {
  outline: 2px solid #a4ceff !important;
}

/* /////////// CHECKBOX //////////////  */
/* The customcheck */
.customcheck {
    display: block;
    position: relative;
    padding-left: 35px;
    padding-top: 5px;
    margin-bottom: 22px;
    font-size: 14px;
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    /* margin-left: -14px; */
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

/* Hide the browser's default checkbox */
.customcheck input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

/* Create a custom checkbox */
.checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 28px;
    width:  28px;
    background-color: rgb(255, 255, 255);
    border-radius: 0px;
    border: solid 2px #b8b8b8;
}

/* On mouse-over, add a grey background color */
.customcheck:hover input ~ .checkmark {
    background-color: #eee;
}

/* When the checkbox is checked, add a blue background */
.customcheck input:checked ~ .checkmark {
    background-color: #ffffff;
    border-radius: 0px;
    border: solid 3px #169a5a;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the checkmark when checked */
.customcheck input:checked ~ .checkmark:after {
    display: block;
}

/* Style the checkmark/indicator */
.customcheck .checkmark:after {
    left: 6px;
    top: 3px;
    width: 10px;
    height: 12px;
    border: solid 2px #169a5a;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}
.msg-error
{
  color: #181918;
  font-size: 14px;
  font-weight: lighter;
  text-align: left;
}
.box-error
{
  padding: 1%;
  background: #F6DB00;
}

.bordes-detalles-auto{
  border-right:black solid 1px
}


</style>